import { render } from "./Topics.vue?vue&type=template&id=6c358c35"
import script from "./Topics.vue?vue&type=script&lang=js"
export * from "./Topics.vue?vue&type=script&lang=js"

import "./Topics.vue?vue&type=style&index=0&id=6c358c35&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__